module.exports = __webpack_public_path__ + "assets/alerts/alert-2cb5fcc565290a4f96c7255ab1ad94e1.png";